"use client"

import { useEffect } from 'react'
import { TextCylinder } from '@/components/ui/TextCylinder'
import { useTitleHistory } from './hooks/useTitleHistory'
import type { TooltipDirection } from './hooks/useTooltipDirection'

export interface TooltipTitleCylinderProps {
  title: string
  direction: TooltipDirection
  className?: string
  maxHistory?: number
}

export function TooltipTitleCylinder({
  title,
  direction,
  className,
  maxHistory = 10,
}: TooltipTitleCylinderProps) {
  const { titles, currentIndex, addTitle, reset } = useTitleHistory({
    maxHistory,
  })

  useEffect(() => {
    if (title) {
      addTitle(title, direction)
    }
  }, [title, direction, addTitle])

  useEffect(() => {
    return () => {
      reset()
    }
  }, [reset])

  const { cylinderElement } = TextCylinder({
    items: titles.length > 0 ? titles : [title],
    autoRotate: false,
    duration: 400,
    easing: 'cubic-bezier(0.4, 0.0, 0.2, 1)',
    perspective: 600,
    radius: 30,
    width: '100%',
    height: 24,
    className,
  })

  return cylinderElement
}
